import { render, staticRenderFns } from "./ComplaintsByChannelDashboard.vue?vue&type=template&id=2438a6f8&scoped=true&"
import script from "./ComplaintsByChannelDashboard.vue?vue&type=script&lang=js&"
export * from "./ComplaintsByChannelDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438a6f8",
  null
  
)

export default component.exports